import { Departments } from '@/types';

export namespace profileTypes {
  export type Profile = {
    _id: string;
    account: {
      _id: string;
    };
    name: string;
    department: Departments;
    op: number;
    pages: {
      _id: string;
      name?: string;
    }[];
  };

  export type AddProfile = (data: {
    name: string;
    department: Departments;
    op: number;
  }) => Promise<{ profile: profileTypes.Profile }>;

  export type GetProfiles = (params: {
    department: Departments;
  }) => Promise<{ profiles: profileTypes.Profile[] }>;

  export type AddProfilePage = (data: { profileId: string; pageId: string }) => Promise<void>;

  export type RemoveProfilePage = (params: { profileId: string; pageId: string }) => Promise<void>;
}
